import { render } from "./AllergenList.vue?vue&type=template&id=3551a6d2&scoped=true"
import script from "./AllergenList.vue?vue&type=script&lang=js"
export * from "./AllergenList.vue?vue&type=script&lang=js"

import "./AllergenList.vue?vue&type=style&index=0&id=3551a6d2&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3551a6d2"]])

export default __exports__